var map = {
	"./Holly_VER_Blue_EN 1.png": 3161,
	"./ID_LOGO.png": 5192,
	"./bansaiPicture.png": 4919,
	"./hephiggs2.png": 1551,
	"./logos/icon_nav_bar.png": 9607,
	"./logos/icon_nav_bar_2.png": 2851,
	"./murex_logo.png": 7514,
	"./psicIvonneLara.png": 9873,
	"./second_chance_img.png": 9632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;